import { Truck, Store, PackageSearch, ExternalLink, Mail } from "lucide-react";
import InnerHero from "@/components/InnerHero";
import Reveal from "@/components/Reveal";
import { TRACK_URL, EMAIL } from "@/data";

const FEATURES = [
    {
        icon: Truck,
        title: "Envíos a todo el recorrido",
        desc: "Llevamos tus encomiendas por las rutas de El Cometa Bis de forma rápida y segura.",
    },
    {
        icon: Store,
        title: "Retiro en boletería",
        desc: "Despachá y retirá tus paquetes en nuestras boleterías habilitadas.",
    },
    {
        icon: PackageSearch,
        title: "Seguimiento en línea",
        desc: "Consultá el estado de tu encomienda con los datos del comprobante.",
    },
];

export default function Encomiendas() {
    return (
        <div data-testid="encomiendas-page">
            <InnerHero
                variant="dark"
                image="/images/encomiendas-hero.webp"
                crumb="Encomiendas"
                title="Seguí tu encomienda"
                subtitle="Consultá el estado de tu encomienda ingresando los datos del comprobante. Rápido, seguro y en línea."
            />

            {/* TRACKING */}
            <section className="py-20 lg:py-28">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <Reveal>
                        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
                            <div>
                                <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand">
                                    Seguimiento online
                                </p>
                                <h2 className="mt-3 font-display text-4xl sm:text-5xl font-extrabold uppercase tracking-tight text-ink">
                                    Rastreá tu envío
                                </h2>
                            </div>
                            <a
                                href={TRACK_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="encomiendas-open-tab"
                                className="inline-flex items-center gap-2 rounded-full border border-black/10 px-6 py-3 text-sm font-bold uppercase tracking-wide text-ink transition-colors hover:border-brand hover:text-brand"
                            >
                                Abrir en pestaña nueva
                                <ExternalLink className="h-4 w-4" />
                            </a>
                        </div>
                    </Reveal>

                    <Reveal delay={0.1}>
                        <div className="mt-8 overflow-hidden rounded-[28px] border border-black/10 bg-white shadow-lg">
                            <iframe
                                src={TRACK_URL}
                                title="Seguimiento de encomiendas El Cometa Bis"
                                data-testid="encomiendas-iframe"
                                className="h-[620px] w-full"
                            />
                        </div>
                        <p className="mt-4 text-sm text-ink/60">
                            ¿No ves el buscador de encomiendas? Abrilo directamente
                            en el{" "}
                            <a
                                href={TRACK_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="font-semibold text-brand hover:underline"
                            >
                                portal de seguimiento
                            </a>
                            .
                        </p>
                    </Reveal>
                </div>
            </section>

            {/* FEATURES */}
            <section className="pb-20 lg:pb-28">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <div className="grid gap-5 md:grid-cols-3">
                        {FEATURES.map((f, i) => (
                            <Reveal key={f.title} delay={i * 0.08}>
                                <div className="h-full rounded-3xl border border-black/5 bg-white p-8 shadow-sm">
                                    <span className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-light text-brand">
                                        <f.icon className="h-7 w-7" />
                                    </span>
                                    <h3 className="mt-5 text-lg font-extrabold uppercase tracking-tight text-ink">
                                        {f.title}
                                    </h3>
                                    <p className="mt-2 text-sm text-ink/60">
                                        {f.desc}
                                    </p>
                                </div>
                            </Reveal>
                        ))}
                    </div>

                    <Reveal delay={0.1}>
                        <div className="mt-8 flex flex-col items-center gap-3 rounded-3xl bg-brand-light p-8 text-center sm:flex-row sm:justify-center">
                            <Mail className="h-5 w-5 text-brand" />
                            <p className="text-sm font-medium text-ink">
                                ¿Consultas sobre tu envío? Escribinos a{" "}
                                <a
                                    href={`mailto:${EMAIL}`}
                                    className="font-bold text-brand hover:underline"
                                >
                                    {EMAIL}
                                </a>
                            </p>
                        </div>
                    </Reveal>
                </div>
            </section>
        </div>
    );
}
